/**
 * 
 */
function CallPainting(type, id, title, dataJson, equivalencesJson, seriesJson, legendJson, chartWidth, chartHeight) {
    // Añadimos # a los Ids para que el selector de d3 funcione correctamente

    var containerId = '#' + id;
    var tooltipId = '#' + id + 'Tooltip';

    // Recuperamos estructuras de datos
    let data = JSON.parse(dataJson);
    let equivalences = JSON.parse(equivalencesJson);
    let series = JSON.parse(seriesJson);
    let legend = JSON.parse(legendJson);

    switch (type) {
        case "pie":
            PaintPie(containerId, tooltipId, data, equivalences, series, legend, chartWidth, chartHeight, 0);
            break;
        case "donut":
            PaintPie(containerId, tooltipId, data, equivalences, series, legend, chartWidth, chartHeight, .7);
            break;
        case "columns":
            PaintColumns(containerId, tooltipId, data, equivalences, series, legend, chartWidth, chartHeight, false);
            break;
        case "columnsstacked":
            PaintColumns(containerId, tooltipId, data, equivalences, series, legend, chartWidth, chartHeight, true);
            break;
        case "columnsandlines":
            break;
        case "trend":
            PaintTrendDCO(containerId, tooltipId, data, equivalences, series, legend, title, id);
            break;
        case "landscape":
            PaintLandscape(containerId, tooltipId, data, equivalences, series, legend, chartWidth, chartHeight, true);
            break;
    }
}

function CallError(id, text, title) {

    //Añadimos el texto del título traducido
    d3.select('#' + id + 'Title')
        .append('span')
        .attr('class', 'DashboardHeaderTitle')
        .html(title);

    //Añadimos el texto del error traducido
    d3.select('#' + id)
        .append('span')
        .attr('class', 'DashboardErrorMsg')
        .html(text);

}

/********************************************************************************************************************************************************
 * Pie
*********************************************************************************************************************************************************/
function PaintPie(containerId, tooltipId, data, equivalences, series, legend, chartWidth, chartHeight, innerRadius) {
    // Definimos constantes de tamaño
    const margin = { top: 5, right: 10, bottom: 5, left: 10 };
    const width = chartWidth - margin.left - margin.right;
    const height = chartHeight - margin.top - margin.bottom;
    const radius = Math.min(width, height) / 2;

    // Recuperamos contenedores
    const container = d3.select(containerId);
    const tooltip = d3.select(tooltipId);

    // Creamos el objeto pie (d3.pie configurado)
    const pie = d3
        .pie()
        .padAngle(2 / radius)
        .sort(null)
        .value((d) => d.value); // Cambiar para usar el valor directamente

    // Creamos el objeto arc (d3.arc configurado)
    const arc = d3
        .arc()
        .innerRadius(radius * innerRadius)
        .outerRadius(radius);

    // Definimos subcategorías
    const subcategories = GetSubCategories(data, series);

    // Buscamos la serie con Type "TotalInsideDonut"
    let serieInsideDonut = series.find(s => s.Type === "TotalInsideDonut") || { Name: "" };

    // Definimos colores
    const colors = GetSeriesColors(subcategories, series);

    // Aplicamos agrupaciones
    let pieData;
    if (legend.grouping.length > 0) {
        let groupedData = {};
        for (let [key, value] of Object.entries(data)) {
            for (let [k, v] of Object.entries(value)) {
                groupedData[k] = (groupedData[k] == undefined ? 0 : groupedData[k]) + parseInt(v);
            }
        }
        pieData = { "": groupedData };
    }
    else {
        pieData = data;
    }

    // Creamos el contenedor de gráficos
    let svgContainer = container
        .append('div')
        .attr('class', 'DashboardChartContiner');

    // Creamos un gráfico para cada bloque de datos
    for (let [gKey, gValue] of Object.entries(pieData)) {
        // Añadimos un gráfico al contenedor
        let svg = svgContainer
            .append('svg')
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom);

        // Añadimos un objeto graphics (g) al svg
        let g = svg.append('g');
        g.attr('transform', `translate(${(width + margin.left + margin.right) / 2}, ${(height + margin.top + margin.bottom) / 2})`);

        let lstKeyValuePair = [];
        for (let [k, v] of Object.entries(gValue)) {
            //Añadimos todos excepto los filtros que coincida con el nombre de la serie de type TotalInsideDonut
            if (!serieInsideDonut || serieInsideDonut.Name !== k) {
                lstKeyValuePair.push({ key: k, value: v });
            }
        }

        // Asignamos los datos, los colores y el objeto de pintado (arc)
        g.selectAll()
            .data(pie(lstKeyValuePair)) // Asignamos datos del gráfico
            .join('path')
            .attr('fill', (d) => colors(d.data.key)) // Asignamos colores
            .attr('d', arc)
            .on('mouseover', (event, d) => {
                // Mostrar tooltip
                let x = event.clientX;
                let y = event.clientY;
                let infoHtml = `${equivalences[d.data.key] == undefined ? d.data.key : equivalences[d.data.key]}: ${d.data.value}`;
                tooltip
                    .html(infoHtml)
                    .style('left', `${x + 20}px`)
                    .style('top', `${y + 10}px`)
                    .style('opacity', 1);
            })
            .on('mousemove', (event) => {
                // Movemos tooltip
                let x = event.clientX;
                let y = event.clientY;
                tooltip.style('left', `${x + 20}px`).style('top', `${y + 10}px`);
            })
            .on('mouseout', () => {
                // Ocultamos tooltip
                tooltip.style('opacity', 0);
            })
            // Transición al pintar el gráfico
            .transition()
            .ease(d3.easeExp)
            .duration(2000)
            .attrTween('d', function (d) {
                var start = { startAngle: 0 * Math.PI, endAngle: 0 * Math.PI };
                var interpolate = d3.interpolate(start, d);
                return function (t) {
                    return arc(interpolate(t));
                };
            });

        // CH totales por cada año para incluir en el centro del donut.
        let totalChByYear = {};
        if (serieInsideDonut) {
            for (let [year, values] of Object.entries(data)) {
                totalChByYear[year] = parseInt(values[serieInsideDonut.Name]) || 0;
            }
        }

        if (gKey !== "") {
            // Añadimos el texto en el centro del gráfico
            g.append('text')
                .attr('y', '1px')
                .style('alignment-baseline', 'middle')
                .append('tspan')
                .attr('font-family', 'sans-serif')
                .attr('font-size', 35)
                .attr('text-anchor', 'middle')
                .attr('font-weight', 'bold')
                .text(gKey);

            // Obtiene el total de ch para el año actual
            let totalCh = totalChByYear[gKey] || 0;

            // Añadimos el total de chargebacks debajo del año
            g.append('text')
                .attr('y', '29px') // Colocamos el texto debajo del año
                .style('alignment-baseline', 'middle')
                .append('tspan')
                .attr('font-family', 'sans-serif')
                .attr('font-size', 20)
                .attr('text-anchor', 'middle')
                .attr('font-weight', 'bold')
                .attr('fill', '#2D82BE')
                .text(totalCh + " " + (equivalences[serieInsideDonut.Name] == undefined ? serieInsideDonut.Name : equivalences[serieInsideDonut.Name]));
        }
    }

    // Obtener solo las subcategorías que deben pintarse y no sean de tipo "TotalInsideDonut"
    const subcategoriesFiltered = subcategories.filter((s) => {
        let seriesConfig = series.find((serie) => serie.Name === s);
        return !seriesConfig || seriesConfig.Type !== "TotalInsideDonut";
    });

    // Añadimos leyenda
    PaintLegend(legend, container, data, equivalences, subcategoriesFiltered, colors, series);
}

/********************************************************************************************************************************************************
 * Columns
*********************************************************************************************************************************************************/
function PaintColumns(containerId, tooltipId, data, equivalences, series, legend, chartWidth, chartHeight, stacked) {
    // Definimos constantes de tamaño
    const margin = { top: 10, right: 10, bottom: 40, left: 40 };
    const width = chartWidth - margin.left - margin.right;
    const height = chartHeight - margin.top - margin.bottom;

    // Recuperamos contenedores
    const container = d3.select(containerId);
    const tooltip = d3.select(tooltipId);

    // Creamos el contenedor de gráficos
    let svgContainer = container
        .append('div')
        .attr('class', 'DashboardChartContiner');

    // Añadimos un svg al contenedor
    const outerSvg = svgContainer
        .append('svg')
        .attr('width', chartWidth)
        .attr('height', chartHeight);

    //para test. descomentar para visualizar el efecto de los mágenes
    //outersvg.append("rect")
    //    .attr('width', "100%")
    //    .attr('height', "100%")
    //    .attr("fill", "#aaaaaa");

    const svg = outerSvg
        .append('g')
        .attr('transform', `translate(${margin.left},${margin.top})`)
        .attr('width', width)
        .attr('height', height);

    // Para test. Descomentar para visualizar el efecto de los mágenes
    //svg.append("rect")
    //    .attr('width', width)
    //    .attr('height', height)
    //    .attr("fill", "#bbbbbb");


    // Definimos subcategorías
    const subcategories = GetSubCategories(data, series);

    // Definimos colores
    const colors = GetSeriesColors(subcategories, series);

    // Definimos el eje x
    const xScale = d3
        .scaleBand()
        .domain(Object.keys(data).map((d) => d))
        .range([0, width])
        .padding(0.2);
    const xAxis = d3.axisBottom(xScale);

    // Pintamos el eje x
    svg.append('g')
        .attr('transform', `translate(0,${height})`)
        .call(xAxis)
        .selectAll("text")
        .attr("transform", "rotate(-45)") // Rotar el texto 45 grados
        .style("text-anchor", "end") // Anclar el texto al final para que no se superponga

    // Definimos el eje y
    let maxYScale;
    if (stacked) {
        maxYScale = Math.max(...Object.keys(data).map(k => {
            return Object.values(data[k]).map(val => val).reduce((partialsum, value) => partialsum + (isNaN(value) ? 0 : Number(value)), 0);
        }));
    }
    else {
        maxYScale = Math.max(...Object.keys(data).map(k => Math.max(...Object.values(data[k]))));
    }
    let maxYScaleRounding = Math.round((maxYScale * 1.1) / 10) * 10 || Math.ceil(maxYScale * 1.1);
    const yScale = d3.scaleLinear().domain([0, maxYScaleRounding]).range([height, 0]);
    const yAxis = d3.axisLeft(yScale).ticks(10);

    // Pintamos el eje y
    let yAxisMarks = svg.append('g')
        .call(yAxis);

    // Líneas de ticks en el gráfico (desactivamos)
    //yAxisMarks.selectAll("g")
    //    .append("line")
    //    .attr("x2", width)
    //    .attr("stroke", "currentColor")
    //    .attr("stroke-dasharray", "2 5")
    //    ;

    // Pintamos datos
    if (stacked) {
        DrawColumnsStackedDCO(svg, data, tooltip, xScale, yScale, maxYScaleRounding, colors, equivalences, series);
    }
    else {
        DrawColumns(svg, data, tooltip, xScale, yScale, maxYScaleRounding, height, colors, equivalences);
    }

    // Añadimos leyenda
    PaintLegend(legend, container, data, equivalences, subcategories, colors, series);
}

function DrawColumns(svg, data, tooltip, xScale, yScale, maxYScaleRounding, height, colors, equivalences) {
    // Barras con tooltip
    svg
        .selectAll('.layer')
        .data(Object.keys(data))
        .enter()
        .append('g')
        .attr('transform', (d) => `translate(${xScale(d)},0)`)
        // iterar sobre cada categoria de key
        .each(function (d, index) {
            const xSubScale = d3
                .scaleBand()
                .domain(Object.entries(data[d]).map(kvp => kvp[0]))
                .range([0, xScale.bandwidth()])
                .padding(0.1);

            // Para cada grupo (nombre), iteramos sobre las categorías
            const group = d3.select(this); // Seleccionar el grupo actual
            let outerIndex = index + 1;
            group.on('mouseover', (event, d) => {
                let x = event.clientX; //event.pageX;
                let y = event.clientY; //event.pageY;

                tooltip
                    .style('opacity', 1)
                    .html(
                        `
                            <strong>${d} </strong><br>
                          ${Object.entries(data[d]).map(kvp => `${equivalences[kvp[0]] == undefined ? kvp[0] : equivalences[kvp[0]]}: ${kvp[1]}`).join("<br>")}
                          `
                    )
                    .style('left', `${x + 20}px`)
                    .style('top', `${y + 10}px`);
            })
                .on('mousemove', (event) => {
                    let x = event.clientX; //event.pageX;
                    let y = event.clientY; //event.pageY;
                    tooltip.style('left', `${x + 20}px`).style('top', `${y + 10}px`);
                })
                .on('mouseout', () => {
                    //console.log('mouseout');
                    tooltip.style('opacity', 0);
                })


            Object.entries(data[d]).forEach((kvp, index) => {
                const value = Number(kvp[1]);
                const subGroup = group.append("g");

                subGroup.append("rect")
                    .attr("width", xSubScale.bandwidth()) // Ancho de la barra
                    .attr("x", xSubScale(kvp[0])) // Ancho de la barra
                    .attr("fill", colors(kvp[0])) // Color basado en la categoría
                    .attr("height", 0) // Comienza con altura 0
                    .attr("y", height) // Comienza desde la altura acumulada
                    .transition() // Iniciar la transición
                    .delay(0) // Retraso para crear el efecto secuencial
                    .duration(1000) // Duración de la transición
                    .attr("height", yScale(maxYScaleRounding - value)) // Altura del 
                    .attr("y", height - yScale(maxYScaleRounding - value)); // Altura del 


            });

        });
}

function DrawColumnsStacked(svg, data, tooltip, xScale, yScale, maxYScaleRounding, colors, equivalences) {
    svg
        .selectAll('.layer')
        .data(Object.keys(data))
        .enter()
        .append('g')
        .attr('transform', (d) => `translate(${xScale(d)},0)`)
        .each(function (d) {
            let cumulativeHeight = 0;
            const group = d3.select(this);

            // Añadimos barras apiladas
            Object.entries(data[d]).forEach((akv, index) => {
                const key = akv[0];
                const value = Number(akv[1]);
                group.append("rect")
                    .attr("x", 0)
                    .attr("width", xScale.bandwidth())
                    .attr("fill", colors(akv[0]))
                    .attr("y", yScale(cumulativeHeight))
                    .attr("height", 0)
                    .transition()
                    .delay(cumulativeHeight / maxYScaleRounding * 2000)
                    .duration(value / maxYScaleRounding * 2000)
                    .attr("y", yScale(cumulativeHeight + value))
                    .attr("height", yScale(cumulativeHeight) - yScale(cumulativeHeight + value));

                cumulativeHeight += value;
            });

            // Añadimos tooltip
            group
                .on('mouseover', (event, d) => {
                    let x = event.clientX;
                    let y = event.clientY;

                    // Calcular el total
                    const total = Object.values(data[d]).reduce((sum, value) => sum + Number(value), 0);

                    tooltip
                        .style('opacity', 1)
                        .html(
                            `<strong>${d}</strong><br>
                            <table>
                                <thead>
                                    <tr>
                                    </tr>
                                </thead>
                                <tbody>
                                    ${Object.entries(data[d]).map(([key, value]) => `
                                        <tr>
                                            <td>${equivalences[key] || key}</td>
                                            <td>${value}</td>
                                        </tr>
                                    `).join('')}
                                    <tr>
                                        <td><strong>Total</strong></td>
                                        <td><strong>${total}</strong></td>
                                    </tr>
                                </tbody>
                            </table>`
                        )
                        .style('left', `${x + 20}px`)
                        .style('top', `${y + 10}px`);
                })
                .on('mousemove', (event) => {
                    let x = event.clientX;
                    let y = event.clientY;
                    tooltip.style('left', `${x + 20}px`).style('top', `${y + 10}px`);
                })
                .on('mouseout', () => {
                    tooltip.style('opacity', 0);
                });
        });
}

function DrawColumnsStackedDCO(svg, data, tooltip, xScale, yScale, maxYScaleRounding, colors, equivalences, series) {
    svg
        .selectAll('.layer')
        .data(Object.keys(data))
        .enter()
        .append('g')
        .attr('transform', (d) => `translate(${xScale(d)},0)`)
        .each(function (d) {
            let cumulativeHeight = 0;
            const group = d3.select(this);

            // Dibujamos barras
            Object.entries(data[d]).forEach((akv) => {
                const key = akv[0];
                const value = Number(akv[1]);
                
                // BUSCAMOS EL COLOR EN EL ARRAY SERIES
                const serieInfo = series.find(s => s.Name === key);
                const barColor = serieInfo ? serieInfo.Color : "#ccc";

                group.append("rect")
                    .attr("x", 0)
                    .attr("width", xScale.bandwidth())
                    .attr("fill", barColor) // <--- Color forzado desde la serie
                    .attr("y", yScale(cumulativeHeight))
                    .attr("height", 0)
                    .transition()
                    .duration(800)
                    .attr("y", yScale(cumulativeHeight + value))
                    .attr("height", Math.max(0, yScale(cumulativeHeight) - yScale(cumulativeHeight + value)));

                cumulativeHeight += value;
            });

            // Tooltip con colores
            group
                .on('mouseover', (event, d) => {
                    let html = `<div style="font-weight:bold; color:#4db8ff; margin-bottom:8px; border-bottom:1px solid #444; padding-bottom:4px;">${d}</div>`;
                    
                    Object.entries(data[d]).forEach(([key, value]) => {
                        const serieInfo = series.find(s => s.Name === key);
                        const color = serieInfo ? serieInfo.Color : "#fff";
                        const label = equivalences[key] || key;
                        
                        html += `
                            <div style="display:flex; justify-content:space-between; align-items:center; gap:15px; margin-bottom:4px;">
                                <div style="display:flex; align-items:center;">
                                    <div style="width:10px; height:10px; background-color:${color}; border-radius:2px; margin-right:8px;"></div>
                                    <span style="color:#eee;">${label}:</span>
                                </div>
                                <span style="font-weight:bold; color:#fff;">${value}</span>
                            </div>`;
                    });

                    tooltip.style('opacity', 1).html(html)
                        .style('left', `${event.clientX + 20}px`)
                        .style('top', `${event.clientY - 20}px`);
                })
                .on('mousemove', (event) => {
                    tooltip.style('left', `${event.clientX + 20}px`).style('top', `${event.clientY - 20}px`);
                })
                .on('mouseout', () => tooltip.style('opacity', 0));
        });
}


/********************************************************************************************************************************************************
 * Landscape
*********************************************************************************************************************************************************/
function PaintLandscape(containerId, tooltipId, data, equivalences, series, legend, chartWidth, chartHeight) {

    // Definimos subcategorías
    const subcategories = GetSubCategories(data, series);

    // Definimos colores
    const colors = GetSeriesColors(subcategories, series);

    // Definimos constantes de tamaño
    const margin = { top: 10, right: 10, bottom: 40, left: 100 };
    const width = chartWidth - margin.left - margin.right;
    const height = chartHeight - margin.top - margin.bottom;

    // Recuperamos contenedores
    const container = d3.select(containerId);
    const tooltip = d3.select(tooltipId);

    // Creamos el contenedor de gráficos
    let svgContainer = container
        .append('div')
        .attr('class', 'DashboardChartContiner');

    // Añadimos un svg al contenedor
    const outerSvg = svgContainer
        .append('svg')
        .attr('width', chartWidth)
        .attr('height', chartHeight);

    const svg = outerSvg
        .append('g')
        .attr('transform', `translate(${margin.left},${margin.top})`)
        .attr('width', width)
        .attr('height', height);

    if (Object.keys(data).length > 1) {

        const yScale = d3
            .scaleBand()
            .domain(Object.keys(data).map((d) => d))
            .range([0, height])
            .padding(0.2);
        const yAxis = d3.axisLeft(yScale);

        // Pintamos el eje y
        svg.append('g')
            .call(yAxis)
            .selectAll("text")
            .style("text-anchor", "end");

        // Definimos el eje x (ahora será el eje horizontal)
        let maxXScale;
        maxXScale = Math.max(...Object.keys(data).map(k => Math.max(...Object.values(data[k]))));

        let maxXScaleRounding = Math.round((maxXScale * 1.1) / 10) * 10;
        const xScale = d3.scaleLinear().domain([0, maxXScaleRounding]).range([0, width]);
        const xAxis = d3.axisBottom(xScale).ticks(10);

        // Pintamos el eje x
        svg.append('g')
            .attr('transform', `translate(0,${height})`)
            .call(xAxis);

        svg
            .selectAll('.layer')
            .data(Object.keys(data))
            .enter()
            .append('g')
            .attr('transform', (d) => `translate(0,${yScale(d)})`)
            // iterar sobre cada categoria de key
            .each(function (d, index) {
                const ySubScale = d3
                    .scaleBand()
                    .domain(Object.entries(data[d]).map(kvp => kvp[0]))
                    .range([0, yScale.bandwidth()])
                    .padding(0.1);

                // Para cada grupo (nombre), iteramos sobre las categorías
                const group = d3.select(this);
                let outerIndex = index + 1;
                group.on('mouseover', (event, d) => {
                    let x = event.clientX;
                    let y = event.clientY;

                    tooltip
                        .style('opacity', 1)
                        .html(
                            `
                        <strong>${d} </strong><br>
                      ${Object.entries(data[d]).map(kvp => `${equivalences[kvp[0]] == undefined ? kvp[0] : equivalences[kvp[0]]}: ${kvp[1]}`).join("<br>")}
                      `
                        )
                        .style('left', `${x + 20}px`)
                        .style('top', `${y + 10}px`);
                })
                    .on('mousemove', (event) => {
                        let x = event.clientX;
                        let y = event.clientY;
                        tooltip.style('left', `${x + 20}px`).style('top', `${y + 10}px`);
                    })
                    .on('mouseout', () => {
                        tooltip.style('opacity', 0);
                    });

                Object.entries(data[d]).forEach((kvp, index) => {
                    const value = Number(kvp[1]);
                    const subGroup = group.append("g");

                    subGroup.append("rect")
                        .attr("height", ySubScale.bandwidth()) // Ancho de la barra
                        .attr("y", ySubScale(kvp[0]))
                        .attr("fill", colors(kvp[0])) // Color basado en la categoría
                        .attr("width", 0) // Comienza con altura 0
                        .attr("x", 0) // Comienza desde la altura acumulada
                        .transition()
                        .delay(0)
                        .duration(1000)
                        .attr("width", xScale(value));

                    // Añadir el texto al final de la barra
                    subGroup.append("text")
                        .attr("x", xScale(value) + 5) // Posición x al final de la barra
                        .attr("y", ySubScale(kvp[0]) + ySubScale.bandwidth() / 2) // Centrar el texto verticalmente
                        .attr("dy", ".35em") // Ajuste vertical
                        .attr("fill", colors(kvp[0])) // Mismo color que la barra
                        .style("font-weight", "bold") // Texto en negrita
                        .style("font-size", "12px")
                        .text(value);
                });
            });

    } else {

        const datosArray = Object.entries(data[Object.keys(data)[0]]).map(([nombre, valor]) => ({ nombre, valor }));

        // Escalas
        let maxXScale = Math.max(...datosArray.map(d => d.valor));
        let maxXScaleRounding = Math.round((maxXScale * 1.1) / 10) * 10;
        const x = d3.scaleLinear()
            .domain([0, maxXScaleRounding])
            .range([0, width]);

        const y = d3.scaleBand()
            .domain(Object.keys(data).length > 1 ? Object.keys(data) : datosArray.map(d => d.nombre))
            .range([0, height])
            .padding(0.1);

        // Ejes
        const ejeX = d3.axisBottom(x);
        const ejeY = d3.axisLeft(y);

        // Dibujar eje Y con nombres
        svg.append("g")
            .call(ejeY);

        // Dibujar eje X
        svg.append("g")
            .attr("transform", `translate(0,${height})`)
            .call(ejeX);
        // Crear barras con animación para un solo dato
        datosArray.forEach((d, i) => {
            svg.append("rect")
                .attr("x", 0)
                .attr("y", y(d.nombre)) // Ajuste para evitar superposición
                .attr("height", y.bandwidth()) // Ajuste para usar todo el bandwidth
                .attr("fill", colors(i)) // Asignar un color diferente basado en el índice
                .attr("width", 0) // Iniciar en 0 para la animación
                .transition()
                .duration(2000)
                .delay(i * 100) // Añadir un retraso basado en el índice
                .attr("width", x(d.valor))
                .on("end", function () { // Evento al finalizar la animación
                    d3.select(this.parentNode)
                        .selectAll(".etiqueta-valor")
                        .transition()
                        .duration(500)
                        .style("opacity", 1);
                });
        });

        // Añadir valores al final de las barras
        svg.selectAll(".etiqueta-valor")
            .data(datosArray)
            .enter()
            .append("text")
            .attr("class", "etiqueta-valor")
            .attr("x", d => x(d.valor) + 5) // 5px de margen después de la barra
            .attr("y", d => y(d.nombre) + y.bandwidth() / 2)
            .attr("dy", "0.35em")
            .style("fill", "black")
            .style("font-size", "12px")
            .style("opacity", 0) // Iniciar transparentes
            .text(d => d.valor);




    }


    // Añadimos leyenda
    PaintLegend(legend, container, data, equivalences, subcategories, colors, series);
}
/********************************************************************************************************************************************************
 * ColumnsAndLines (borrar)
 * No tiene sentido. Debería haber un único pintado de gráfico, y en función del estilo de la serire que se pinte como deba.
*********************************************************************************************************************************************************/
var PaintColumnsAndLines = function (svgId, dataArray, equivalences, tooltipId) {
    const margin = { top: 20, right: 50, bottom: 50, left: 50 };
    const width = 800 - margin.left - margin.right;
    const height = 400 - margin.top - margin.bottom;

    const svg = d3
        .select(svgId)
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)
        .append('g')
        .attr('transform', `translate(${margin.left},${margin.top})`);

    const tooltip = d3.select(tooltipId);

    // Escalas
    const xScale = d3
        .scaleBand()
        .domain(dataArray.map((d) => d.column))
        .range([0, width])
        .padding(0.2);

    // obtener el maximo valor de y
    let maxYScale = Math.max(...dataArray.map((value) => value.columnValue));
    // redondeamos al sig maximo de potencia de 10

    let maxYScaleRounding = Math.round((maxYScale * 1.1) / 10) * 10 || Math.ceil(maxYScale * 1.1);

    const yScale = d3
        .scaleLinear()
        .domain([0, maxYScaleRounding])
        .range([height, 0]);

    // Ejes
    const xAxis = d3.axisBottom(xScale);
    const yAxis = d3.axisLeft(yScale);

    svg.append('g').attr('transform', `translate(0,${height})`).call(xAxis);

    svg.append('g').call(yAxis);

    // Barras con tooltip
    svg
        .selectAll('.bar')
        .data(dataArray)
        .enter()
        .append('rect')
        .attr('class', 'bar')
        .attr('x', (d) => xScale(d.column))
        .attr('y', height) // Comienza desde el fondo
        .attr('width', xScale.bandwidth())
        .attr('height', 0) // Altura inicial es 0
        .on('mouseover', (event, d) => {
            let x = event.clientX; //event.pageX;
            let y = event.clientY; //event.pageY;
            //console.log('getBoundingClientRect', x, y);

            tooltip
                .style('opacity', 1)
                .html(
                    `
                    <strong>${d.column}</strong><br>
                    Valor columna: ${d.columnValue}<br>
                    Línea roja: ${d.red}<br>
                    Línea azul: ${d.blue}
                `
                )
                .style('left', `${x + 20}px`)
                .style('top', `${y + 10}px`);
        })
        .on('mousemove', (event) => {
            let x = event.clientX; //event.pageX;
            let y = event.clientY; //event.pageY;
            //console.log('getBoundingClientRect', x, y);
            tooltip.style('left', `${x + 20}px`).style('top', `${y + 10}px`);
        })
        .on('mouseout', () => {
            tooltip.style('opacity', 0);
        })
        .transition()
        .duration(1000)
        .attr('y', (d) => yScale(d.columnValue)) // Altura según el valor de la columna
        .attr('height', (d) => height - yScale(d.columnValue));

    // Valores sobre las columnas
    svg
        .selectAll('.bar-label')
        .data(dataArray)
        .enter()
        .append('text')
        .attr('class', 'label')
        .attr('x', (d) => xScale(d.column) + xScale.bandwidth() / 2)
        .attr('y', (d) => yScale(d.columnValue) - 5)
        .text((d) => d.columnValue);

    // Líneas con animación
    const lineRed = d3
        .line()
        .x((d) => xScale(d.column) + xScale.bandwidth() / 2)
        .y((d) => yScale(d.red));

    const lineBlue = d3
        .line()
        .x((d) => xScale(d.column) + xScale.bandwidth() / 2)
        .y((d) => yScale(d.blue));

    // Línea roja
    const redPath = svg
        .append('path')
        .datum(dataArray)
        .attr('class', 'line-red line-label')
        .attr('d', lineRed);

    const redPathLength = redPath.node().getTotalLength();
    redPath
        .attr('stroke-dasharray', redPathLength)
        .attr('stroke-dashoffset', redPathLength)
        .transition()
        .duration(1000)
        .attr('stroke-dashoffset', 0);

    // Línea azul
    const bluePath = svg
        .append('path')
        .datum(dataArray)
        .attr('class', 'line-blue line-label')
        .attr('d', lineBlue);

    const bluePathLength = bluePath.node().getTotalLength();
    bluePath
        .attr('stroke-dasharray', bluePathLength)
        .attr('stroke-dashoffset', bluePathLength)
        .transition()
        .duration(1000)
        .delay(500) // Retraso para animar después de la roja
        .attr('stroke-dashoffset', 0);

    // colores en la grafica
    let randomPosition1 = Math.floor(Math.random() * (dataArray.length - 2));
    // Títulos dentro del gráfico
    svg
        .append('text')
        .attr('class', 'label')
        .style('font-family', 'sans-serif')
        .style('text-anchor', 'middle')
        .style('font-weight', '600')
        .attr('x', (randomPosition1 * width) / dataArray.length)
        .attr('y', yScale(dataArray[randomPosition1].red) - 20)
        .attr('fill', equivalences['redColor'])
        .text(equivalences['red']);
    svg
        .append('text')
        .attr('class', 'label')
        .style('font-family', 'sans-serif')
        .style('text-anchor', 'middle')
        .style('font-weight', '600')
        .attr('x', ((randomPosition1 + 1) * width) / dataArray.length)
        .attr('y', yScale(dataArray[randomPosition1 + 2].blue) - 20)
        .attr('fill', equivalences['blueColor'])
        .text(equivalences['blue']);
    svg
        .append('text')
        .attr('class', 'label')
        .style('font-family', 'sans-serif')
        .style('text-anchor', 'middle')
        .style('font-weight', '600')
        .attr('x', ((randomPosition1 + 2) * width) / dataArray.length)
        .attr('y', yScale(dataArray[randomPosition1 + 1].columnValue) - 20)
        .attr('fill', equivalences['valueColor'])
        .text(equivalences['value']);
}

/********************************************************************************************************************************************************
 * Data
*********************************************************************************************************************************************************/
function PaintTrend(containerId, tooltipId, data, equivalences, series, legend) {
    // Recuperamos contenedores
    const container = d3.select(containerId);
    const tooltip = d3.select(tooltipId);

    // Recuperamos xAxis
    let xAxis = [];
    for (let x of Object.keys(data)) {
        xAxis.push(x);
    }

    // Buscamos la serie con Type "Tendencies" para los trend de ascenso/descenso
    let serieTendence = series.find(s => s.Type === "Tendencies") || null;
    let isTendencies = serieTendence !== null;

    // Recuperamos valores
    let val1, val2;
    let otherData = null;
    let yAxis = "Total";
    if (series.length > 0) {
        yAxis = series[0].Name;
    }
    val1 = (parseFloat(data[xAxis[1]][yAxis]) || 0);
    val2 = (parseFloat(data[xAxis[0]][yAxis]) || 0);
    let trend = val1 - val2;

    // Cálculo del porcentaje de variación
    let trendPercentage = val2 !== 0 ? ((trend / val2) * 100).toFixed(0) : "0";

    // Obtenemos el año actual y el año anterior
    let currentYear = new Date().getFullYear();
    let previousYear = currentYear - 1;

    // Tendencia con colores invertidos (los descensos son positivos)
    let positiveTrend = trend < 0;

    // Creamos NumberFormat basado en el lenguaje del navegador
    let nFormat = new Intl.NumberFormat(navigator.language, { useGrouping: true });

    // Recuperamos el texto traducido y remplazamos los valores
    let textTrend = (series.length > 0 && series[0].LabelFormat)
        ? (equivalences[series[0].LabelFormat] || series[0].LabelFormat)
        : "";

    // Separamos traduccion de ascenso/descenso y elegimos una según la tendencia
    let trendParts = textTrend ? textTrend.split(";") : ["", ""];
    let finalTextTrend = positiveTrend ? trendParts[0] : trendParts[1];
    finalTextTrend = finalTextTrend
        .replace("##1##", previousYear)
        .replace("##2##", nFormat.format(parseInt(trend)))
        .replace("##3##", series.length > 0 ? (equivalences[series[0].Name] || series[0].Name) : "")
        .replace("##4##", trendPercentage + "%");

    // Recuperamos traduccion "en"
    let textIn = (series.length > 0 && series[0].LabelTrend)
        ? (equivalences[series[0].LabelTrend] || series[0].LabelTrend)
        : "";

    // Cambiamos display del contenedor
    container
        .style("display", "block")
        .style("width", "100%");

    //*** Valor actual ***
    // Creamos contenedor
    let current = container
        .append("div")
        .attr("class", "DashboardTrendCurrent");

    if (isTendencies) {

        // Flecha de tendencia
        current
            .append("i")
            .attr("class", function () {
                return trend >= 0 ? "fas fa-arrow-up" : "fas fa-arrow-down"
            })
            .style('font-size', 12)
            .style('font-weight', 'lighter;')
            .style("color", `${positiveTrend > 0 ? "green" : "red"}`);
        // Valor
        current
            .append("span")
            .style("margin-left", "20px")
            .html(`${nFormat.format(parseInt(val1)) + (series.length > 0 ? " " + (equivalences[series[0].Name] == undefined ? series[0].Name : equivalences[series[0].Name]) : "")}`);

        //*** Tendencia ***
        let tendencia = container
            .append("div")
            .attr("class", "DashboardTrendDif")
            .style("color", `${positiveTrend > 0 ? "green" : "red"}`)
            .html(finalTextTrend);

        //*** Div Tooltip ***
        if (Object.entries(data[xAxis[1]]).length > 1) {
            // Definimos contenido
            let txt = legend.TextTh != null
                ? "<div style=\"font-weight:bold; text-align:center; border-bottom:1px solid #000000;\">" + legend.TextTh + "</div><div style=\"text-align:right;\">"
                : "<div style=\"font-weight:bold; text-align:center; border-bottom:1px solid #000000;\">" + xAxis[1] + "</div><div style=\"text-align:right;\">";
            for (let [k, v] of Object.entries(data[xAxis[1]])) {
                txt += nFormat.format(parseInt(v)) + " " + (equivalences[k] == undefined ? k : equivalences[k]) + "<br />";
            }
            txt += "</div>";

            // Creamos div que muestra el tooltip
            let aData = [{ txt: txt }];
            tendencia
                .selectAll("div")
                .data([txt])
                .enter()
                .append("div")
                .attr("class", "DashboardMoreInfoButton")
                .html((d) => {
                    let bt = legend.ButtonText == undefined ? "-" : legend.ButtonText;
                    return equivalences[bt] == undefined ? bt : equivalences[bt];
                })
                .on('mouseover', (event, d) => {
                    // Mostrar tooltip
                    let x = event.clientX;
                    let y = event.clientY;
                    tooltip
                        .html(d)
                        .style('left', `${x + 20}px`)
                        .style('top', `${y + 10}px`)
                        .style('opacity', 1);
                })
                .on('mousemove', (event) => {
                    // Movemos tooltip
                    let x = event.clientX;
                    let y = event.clientY;
                    tooltip.style('left', `${x + 20}px`).style('top', `${y + 10}px`);
                })
                .on('mouseout', () => {
                    // Ocultamos tooltip
                    tooltip.style('opacity', 0);
                });
        }
        
    } else {

        // Valor
        current
            .append("span")
            .style("margin-left", "20px")
            .html(`${nFormat.format(parseInt(val1)) + (series.length > 0 ? " " + (equivalences[series[0].Name] == undefined ? series[0].Name : equivalences[series[0].Name]) : "")}`);

        //*** Tendencia ***
        let trendValue = data[xAxis[1]][series[1].Name] || 0;
        let trendText = trendValue + series[1].Name + " " + ((series.length > 1 && series[1].LabelFormat)
            ? (equivalences[series[1].LabelFormat] || series[1].LabelFormat)
            : "");
        let tendencia = container
            .append("div")
            .attr("class", "DashboardTrendDif")
            .style("color", `${positiveTrend > 0 ? "green" : "red"}`)
            .html(trendText);     
    }
}

function PaintTrendDCO(containerId, tooltipId, data, equivalences, series, legend, title, id) {
    const container = d3.select(containerId);
    container.html("");

    // 1. Configuración de Temas (Colores e Iconos)
    let config = { icon: "far fa-clock", color: "#34b5e5", bgIconColor: "#eef7ff" };
    const t = title.toLowerCase();

    if (id == 'chartTotal') {
        config = { icon: "fa fa-clock", color: "rgb(47, 186, 238)", bgIconColor: "rgba(47, 187, 238, 0.1)", bgColor : "rgba(47, 187, 238, 0.05)"};
    } else if (id == 'chartMedia') {
        config = { icon: "fas fa-chart-line", color: "rgb(76, 164, 198)", bgIconColor: "rgba(76, 163, 198, 0.1)", bgColor : "rgba(76, 163, 198, 0.05)" };
    } else if (id == 'chartExito') {
        config = { icon: "fa fa-check-circle", color: "rgb(0, 180, 73)", bgIconColor: "rgba(0, 180, 72, 0.1)", bgColor : "rgba(0, 180, 72, 0.05)" };
    }else
    {
        config = { icon: "fas fa-money-bill-wave", color: "rgb(244, 192, 15)", bgIconColor: "rgba(244, 191, 15, 0.1)", bgColor : "rgba(244, 191, 15, 0.05)" };
    }

    // 2. Extraer el valor de forma segura
    let rawValue = 0;
    let serieName;

    try {

        let years = Object.keys(data);
        let lastYear = years[years.length - 1]; // Toma el último año disponible

        if(series.length > 0 && series[0].Name.includes("Currency"))
        {
            data[lastYear] = Object.fromEntries(Object.entries(data[lastYear])
                                    .sort(([, a], [, b]) => parseFloat(b) - parseFloat(a)));

            rawValue = parseFloat(Object.values(data[lastYear])[0]) || 0;
            serieName = Object.keys(data[lastYear])[0];

        } else {

            serieName = series.length > 0 ? series[0].Name : Object.keys(data[lastYear])[0];
            rawValue = parseFloat(data[lastYear][serieName]) || 0; 
        }


    } catch (e) { console.error("Error obteniendo datos D3:", e); }

    // 3. Sufijos
    let suffix = "";
    if (id == 'chartExito') suffix = "%";
    if (id == 'chartImporte') suffix = equivalences[serieName] || "";;

    // 4. Renderizado
    const main = container.append("div")
        .style("display", "flex")
        .style("align-items", "center")
        .style("justify-content", "space-between")
        .style("padding", "10px 15px")
        .style("width", "100%");

    const left = main.append("div")
        .style("display", "flex")
        .style("align-items", "center")
        .style("gap", "12px");

    // Círculo e Icono
    left.append("div")
        .style("width", "36px")
        .style("height", "36px")
        .style("background-color", config.bgIconColor)
        .style("border-radius", "50%")
        .style("display", "flex")
        .style("justify-content", "center")
        .style("align-items", "center")
        .append("i")
        .attr("class", config.icon)
        .style("color", config.color)
        .style("font-size", "20px");

    // Valor
/*     main.append("div")
        .style("font-size", "26px")
        .style("font-weight", "700")
        .style("color", config.color)
        .text(rawValue.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 1 }) + suffix); */
    const div = main.append("div")
        .style("font-size", "26px")
        .style("font-weight", "700")
        .style("color", config.color);

    div.append("span")
        .text(rawValue.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 1
        }));

    div.append("span")
        .style("font-size", "20px")
        .style("font-weight", "900")
        .style("margin-left", "4px")
        .text(suffix);
}


/********************************************************************************************************************************************************
 * Leyendas
*********************************************************************************************************************************************************/
/**
 * Añade leyenda.
 */
function PaintLegend(legend, container, data, equivalences, subcategories, colors, series) {
    // Creamos el contenedor de la leyenda y definimos su posición
    let textTh = legend.TextTh;
    let legendContainer;
    switch (legend.position) {
        case "Top":
            // Creamos contenedor de leyenda
            legendContainer = container
                .insert('div', ':first-child')
                .attr('class', "DashboardLegend");
            break;
        case "Bottom":
        default:
            // Creamos contenedor de leyenda
            legendContainer = container
                .append('div')
                .attr('class', "DashboardLegend");
            break;
        case "Left":
            // Actualizamos la dirección de pintado de elementos flex del DashboardBody
            container.style("flex-direction", "row");
            // Creamos contenedor de leyenda
            legendContainer = container
                .insert('div', ':first-child')
                .attr('class', "DashboardLegend");
            break;
        case "Right":
            // Actualizamos la dirección de pintado de elementos flex del DashboardBody
            container.style("flex-direction", "row");
            // Creamos contenedor de leyenda
            legendContainer = container
                .append('div')
                .attr('class', "DashboardLegend");
            break;
    }

    // Creamos la leyenda especificada
    switch (legend.type) {
        case "Base":
        default:
            PaintLegendBase(legendContainer, data, equivalences, subcategories, colors);
            break;
        case "Table":
            PaintLegendTable(legendContainer, data, equivalences, subcategories, colors, series);
            break;
        case "FullTable":
            PaintLegendFullTable(legendContainer, data, equivalences, subcategories, colors, series);
            break;
        case "FullTableTotal":
            PaintLegendFullTableTotal(legendContainer, data, equivalences, subcategories, colors, textTh, series);
            break;
        case "FullTableText":
            PaintLegendFullTableText(legendContainer, data, equivalences, subcategories, colors, textTh, series);
            break;
        case "Grouping":
            PaintLegendGrouping(legendContainer, data, equivalences, subcategories, colors, legend.Grouping, series);
            break;
        case "None":
            break;
    }
}

/**
 * Añade leyenda Base.
 * Un recuadro que contendrá las diferentes categorías con su nombre y el color que le corresponde.
 */
function PaintLegendBase(legendContainer, data, equivalences, subcategories, colors) {
    // Creamos tabla de leyenda
    const table = legendContainer.append("table").attr("class", "DashboardLegendTable");

    const tbody = table.append("tbody");
    let currentRow;

    // Añadimos elementos a la leyenda
    const maxCols = 6;
    let col = maxCols;
    for (let k of subcategories) {
        if (col == maxCols) {
            col = 0;
            currentRow = tbody.append("tr");
        }

        // Añadimos elementos de la leyenda
        let currentCell = currentRow.append("td").attr('class', 'DashboardLegendTableTD')
            .append("div").style("display","flex");

        // Añadimos cuadro con color
        currentCell
            .append("div")
            .attr('class', 'DashboardLegendItemMark')
            .style("display", "flex")
            .style("background-color", d3.color(colors(k)).rgb());

        // Añadimos texto
        currentCell
            .append("div")
            .style("display", "flex")
            .style("min-height", "30px")
            .style("align-items", "center")
            .style("font-size", "10px")
            .style("color", "#6c757d")
            .style("font-weight", "500")
            .html(function () { return equivalences[k] == undefined ? k : equivalences[k] });

        col++;
    }
}

/**
 * Añade leyenda Table.
 * Se añadirá una tabla con las categorías y subcategorías de los datos.
 */
function PaintLegendTable(legendContainer, data, equivalences, subcategories, colors, series) {
    // Recuperamos headers del dataTable
    let headers = [];
    for (let k of Object.keys(data)) {
        headers.push(k);
    }

    // Calculamos totales
    //let totales = {};
    //for (let [gk, gv] of Object.entries(data)) {
    //    for (let [k, v] of Object.entries(gv)) {
    //        if (k !== "CH") {  // Excluimos CH antes de sumar
    //            totales[gk] = (totales[gk] || 0) + parseInt(v);
    //        }
    //    }
    //}

    // Excluimos la serie con el type TotalInsideDonut
    let excludeKeys = series
        ? series.filter(s => s.Type === "TotalInsideDonut").map(s => s.Name)
        : [];

    //Calculamos totales sin las claves excluidas
    let totales = {};
    for (let [gk, gv] of Object.entries(data)) {
        for (let [k, v] of Object.entries(gv)) {
            if (!excludeKeys.includes(k)) {
                totales[gk] = (totales[gk] || 0) + parseInt(v);
            }
        }
    }

    // Formateamos los datos
    let dataTable = [];
    for (let k of subcategories) {
        let item = [];
        item.push(k);
        for (let gk of headers) {
            let val = (data[gk][k] || 0)
            if (val > 0)
                item.push(parseInt((val * 100 / (totales[gk] || 0))) + ' %');
            else
                item.push("0 %");
        }
        dataTable.push(item);
    }

    // Creamos una tabla para los datos de la leyenda
    headers.unshift("");
    let table = legendContainer.append("table").attr("class", "DashboardLegendTable");

    // Creamos cabeceras
    table
        .append("thead")
        .append("tr")
        .selectAll("th")
        .data(headers)
        .enter()
        .append("th")
        .attr("class", "DashboardLegendTableTH")
        .text(d => d);

    //Añadimos datos
    table
        .append("tbody")
        .selectAll("tr")
        .data(dataTable)
        .enter()
        .append("tr")
        .selectAll("td")
        .data(d => d)
        .enter()
        .append("td")
        .attr("class", "DashboardLegendTableTD DashboardLegendColSep")
        .style("text-align", function (d, i) { return i == 0 ? "left" : "right" })
        .style("color", function (d, i) { return i == 0 && colors(d) != undefined ? d3.color(colors(d)).rgb() : "#000000" })
        .style("font-weight", function (d, i) { return i == 0 ? "bold" : "normal"; })
        .html(function (d, i) {
            return i > 0 || equivalences[d] == undefined ? d : equivalences[d];
        });
}

/**
 * Añade leyenda FullTable.
 * Se añade una tabla con el desglose de subcategorías y sus datos completos (valor-pct).
 */
function PaintLegendFullTable(legendContainer, data, equivalences, subcategories, colors, series) {
    // Recuperamos headers del dataTable
    let headers = [];
    for (let k of Object.keys(data)) {
        headers.push(k);
    }

    // Excluimos la serie con Type "TotalInsideDonut"
    let excludeKeys = series
        ? series.filter(s => s.Type === "TotalInsideDonut").map(s => s.Name)
        : [];

    //Calculamos totales sin las claves excluidas
    let total = 0;
    let totales = {};
    for (let gk of headers) {
        let subtot = 0;
        for (let [k, v] of Object.entries(data[gk])) {
            if (!excludeKeys.includes(k)) {
                subtot += parseInt(v);
                total += parseInt(v);
            }
        }
        totales[gk] = subtot;
    }

    // Formateamos los datos
    let dataTable = [];
    for (let k of subcategories) {
        let item = [];
        item.push({ key: k, value: k });
        item.val = 0;
        for (let gk of headers) {
            let val = (data[gk][k] || 0);
            item.push({ key: k, value: val });
            if (val > 0)
                item.push({ key: k, value: parseInt((val * 100 / (totales[gk] || 0))) + ' %' });
            else
                item.push({ key: k, value: "0 %" });
        }
        dataTable.push(item);
    }

    // Creamos tabla para los datos de la leyenda
    let table = legendContainer
        .append("table")
        .attr("class", "DashboardLegendTable")
        .style("border-collapse", "separate");

    //Añadimos datos
    table
        .append("tbody")
        .selectAll("tr")
        .data(dataTable)
        .enter()
        .append("tr")
        .selectAll("td")
        .data(d => d)
        .enter()
        .append("td")
        .attr("class", "DashboardLegendTableTD")
        .style("padding", function (d, i) { return i == 0 ? "3px 8px 3px 8px" : i % 2 != 0 ? "3px 8px" : "3px 0px 3px 8px" })
        .style("text-align", function (d, i) { return i == 0 ? "left" : "right" })

        .style("color", function (d, i) { return i == 0 ? "#6c757d" : i % 2 == 0 ? d3.color(colors(d.key)) : "#ffffff" })
        .style("background-color", function (d, i) { return i % 2 != 0 ? d3.color(colors(d.key)) : "inherit" })
        .style("border-radius", "3px")
        .html(function (d, i) {
            return i > 0 || equivalences[d.value] == undefined ? d.value : equivalences[d.value];
        });
}

/**
 * Añade leyenda FullTableWithTotals.
 * Se añade una tabla con el desglose de subcategorías y sus datos completos (valor-pct).
 */
function PaintLegendFullTableTotal(legendContainer, data, equivalences, subcategories, colors, textTh, series) {
    // Recuperamos headers del dataTable
    let headers = [];
    for (let k of Object.keys(data)) {
        headers.push(k);
    }

    // Excluimos la serie con Type "TotalInsideDonut"
    let excludeKeys = series
        ? series.filter(s => s.Type === "TotalInsideDonut").map(s => s.Name)
        : [];

    //Calculamos totales sin las claves excluidas
    let total = 0;
    let totales = {};
    for (let gk of headers) {
        let subtot = 0
        for (let [k, v] of Object.entries(data[gk])) {
            if (!excludeKeys.includes(k)) {
                subtot += parseInt(v);
                total += parseInt(v);
            }
        }
        totales[gk] = subtot;
    }

    // Formateamos los datos
    let dataTable = [];
    for (let k of subcategories) {
        let item = [];
        item.push({ key: k, value: k });
        item.val = 0;
        for (let gk of headers) {
            let val = (data[gk][k] || 0);
            item.push({ key: k, value: val });
            if (val > 0)
                item.push({ key: k, value: parseInt((val * 100 / (totales[gk] || 0))) + ' %' });
            else
                item.push({ key: k, value: "0 %" });
        }
        dataTable.push(item);
    }

    // Calculamos la fila extra
    let extraRow = [{ key: "extra", value: textTh }];
    let totalSum = 0;
    for (let gk of headers) {
        let sum = 0;
        for (let k of subcategories) {
            sum += (parseInt(data[gk][k]) || 0);
        }
        totalSum += sum;
        extraRow.push({ key: "extra", value: sum });
        extraRow.push({ key: "extra", value: parseInt((sum * 100 / (totales[gk] || 0))) + ' %' });
    }


    // Creamos tabla para los datos de la leyenda
    let table = legendContainer
        .append("table")
        .attr("class", "DashboardLegendTable")
        .style("border-collapse", "separate");

    // Añadimos la fila extra
    table
        .append("thead")
        .append("tr")
        .selectAll("th")
        .data(extraRow)
        .enter()
        .append("th")
        .attr("class", "DashboardLegendTableTD")
        .style("padding", function (d, i) { return i == 0 ? "3px 15px 3px 15px" : i % 2 != 0 ? "3px 15px" : "3px 0px 3px 15px" })
        .style("color", "#000000")
        .style("font-weight", "bold")
        .html(function (d, i) {
            return i > 0 || equivalences[d.value] == undefined ? d.value : equivalences[d.value];
        })

    // Añadimos datos
    table
        .append("tbody")
        .selectAll("tr")
        .data(dataTable)
        .enter()
        .append("tr")
        .selectAll("td")
        .data(d => d)
        .enter()
        .append("td")
        .attr("class", "DashboardLegendTableTD")
        .style("padding", function (d, i) { return i == 0 ? "3px 15px 3px 15px" : i % 2 != 0 ? "3px 15px" : "3px 0px 3px 15px" })
        .style("text-align", function (d, i) { return i == 0 ? "left" : "right" })
        .style("color", function (d, i) { return i == 0 ? "#7A7D9A" : i % 2 == 0 ? d3.color(colors(d.key)) : "#ffffff" })
        .style("background-color", function (d, i) { return i % 2 != 0 ? d3.color(colors(d.key)) : "inherit" })
        .style("border-radius", "3px")
        .html(function (d, i) {
            return i > 0 || equivalences[d.value] == undefined ? d.value : equivalences[d.value];
        });
}

/**
 * Añade leyenda FullTableWithTotals.
 * Se añade una tabla con el desglose de subcategorías y sus datos completos (valor-pct).
 */
function PaintLegendFullTableText(legendContainer, data, equivalences, subcategories, colors, textTh, series) {
    // Recuperamos headers del dataTable
    let headers = [];
    for (let k of Object.keys(data)) {
        headers.push(k);
    }

    // Excluimos la serie con Type "TotalInsideDonut"
    let excludeKeys = series
        ? series.filter(s => s.Type === "TotalInsideDonut").map(s => s.Name)
        : [];

    //Calculamos totales sin las claves excluidas
    let total = 0;
    let totales = {};
    for (let gk of headers) {
        let subtot = 0
        for (let [k, v] of Object.entries(data[gk])) {
            if (!excludeKeys.includes(k)) {
                subtot += parseInt(v);
                total += parseInt(v);
            }
        }
        totales[gk] = subtot;
    }

    // Formateamos los datos
    let dataTable = [];
    for (let k of subcategories) {
        let item = [];
        item.push({ key: k, value: k });
        item.val = 0;
        for (let gk of headers) {
            let val = (data[gk][k] || 0);
            item.push({ key: k, value: val });
            if (val > 0)
                item.push({ key: k, value: parseInt((val * 100 / (totales[gk] || 0))) + ' %' });
            else
                item.push({ key: k, value: "0 %" });
        }
        dataTable.push(item);
    }

    // Calculamos la fila extra
    let extraRow = [{ key: "extra", value: textTh }];

    // Creamos contenedor para las tablas
    let container = legendContainer.append("div").style("position", "relative");

    // Creamos tabla para la fila extra
    let extraTable = container.append("table")
        .attr("class", "DashboardLegendTable")
        .style("border-collapse", "separate")
        .style("position", "absolute")
        .style("top", "-80px") // Ajusta este valor según sea necesario
        .style("left", "0")
        .style("width", "100%"); // Asegúrate de que la tabla ocupe el 100% del contenedor

    extraTable.append("thead")
        .append("tr")
        .append("th")
        .attr("class", "DashboardLegendTableTD")
        .attr("colspan", headers.length + 1) // Asegúrate de que el colspan cubra todas las columnas
        .style("color", "#000000")
        .style("font-weight", "bold")
        .style("text-align", "center")
        .style("font-size", "20px")
        .html(function (d) {
            return equivalences[extraRow[0].value] == undefined ? extraRow[0].value : equivalences[extraRow[0].value];
        });

    // Creamos tabla para los datos de la leyenda
    let table = container.append("table")
        .attr("class", "DashboardLegendTable")
        .style("border-collapse", "separate")
        .style("position", "relative")
        .style("width", "100%"); // Asegúrate de que la tabla ocupe el 100% del contenedor

    // Añadimos datos
    table.append("tbody")
        .selectAll("tr")
        .data(dataTable)
        .enter()
        .append("tr")
        .selectAll("td")
        .data(d => d)
        .enter()
        .append("td")
        .attr("class", "DashboardLegendTableTD")
        .style("padding", function (d, i) { return i == 0 ? "3px 8px 3px 8px" : i % 2 != 0 ? "3px 15px" : "3px 0px 3px 15px" })
        .style("text-align", function (d, i) { return i == 0 ? "left" : "right" })
        .style("color", function (d, i) { return i == 0 ? "#7A7D9A" : i % 2 == 0 ? d3.color(colors(d.key)) : "#ffffff" })
        .style("background-color", function (d, i) { return i % 2 != 0 ? d3.color(colors(d.key)) : "inherit" })
        .style("border-radius", "3px")
        .html(function (d, i) {
            return i > 0 || equivalences[d.value] == undefined ? d.value : equivalences[d.value];
        });

    // Ajustamos el ancho de la tabla extra para que coincida con la tabla de datos
    setTimeout(function () {
        let legendTableWidth = table.node().getBoundingClientRect().width;
        extraTable.style("width", legendTableWidth + "px");
    }, 0);
}


/**
 * Añade la leyenda de los gráficos pie agrupados.
 * Se muestran pastillas con los datos agrupados en la parte derecha.
 * A su derecha se añade una tabla con el desglose de subcategorías y sus datos.
 */
function PaintLegendGrouping(legendContainer, data, equivalences, subcategories, colors, grouping, series) {
    // Recuperamos headers del dataTable
    let headers = [];
    for (let k of Object.keys(data)) {
        headers.push(k);
    }

    // Excluimos la serie con Type "TotalInsideDonut"
    let excludeKeys = series
        ? series.filter(s => s.Type === "TotalInsideDonut").map(s => s.Name)
        : [];

    // Calculamos totales excluyendo las claves no deseadas
    let total = 0;
    let totales = {};
    for (let gk of headers) {
        let subtot = 0;
        for (let [k, v] of Object.entries(data[gk])) {
            if (!excludeKeys.includes(k)) {
                subtot += parseInt(v);
                if (grouping.some(x => x.Items.includes(k))) {
                    total += parseInt(v);
                }
            }
        }
        totales[gk] = subtot;
    }

    //*** Primer bloque de leyenda ***
    // Agrupamos datos
    let groupedData = [];
    for (let g of grouping) {
        let item = {};
        item.Name = g.Name;
        item.Color = g.Color;
        item.Background = g.Background;
        item.val = 0;
        for (let [gk, gv] of Object.entries(data)) {
            for (let [k, v] of Object.entries(gv)) {
                let val = (data[gk][k] || 0);
                if (g.Items.find((gik) => gik == k)) {
                    item.val += parseInt(val);

                    if (item.val > 0)
                        item.pct = parseInt((item.val * 100 / (total || 0))) + ' %';
                    else
                        item.pct = "0 %";
                }
            }
        }
        groupedData.push(item);
    }

    // Creamos leyenda de agrupaciones
    legendContainer
        .style("flex-direction", "column")
        .style("padding-left", "50px")
        // Creamos elementos de la leyenda
        .selectAll("div")
        .data(groupedData)
        .enter()
        .append("div")
        .attr('class', 'DashboardLegendCardItem')
        .style('background-color', (d) => d.Background)
        // Añadimos porcentajes
        .append('div')
        .attr('class', 'DashboardLegendCardItemPct')
        .style('color', (d) => d.Color)
        .html((d) => d.pct)
        // Añadimos texto de los elementos
        .append('div')
        .html((d) => equivalences[d.Name] == undefined ? d.Name : equivalences[d.Name])
        .attr('class', 'DashboardLegendCardItemTxt');

    //*** Segundo bloque de leyenda ***
    // Formateamos los datos
    let dataTable = [];
    for (let k of subcategories) {
        let item = [];
        item.push({ key: k, value: k });
        item.val = 0;
        for (let gk of headers) {
            let val = (data[gk][k] || 0);
            item.push({ key: k, value: val });
            if (val > 0)
                item.push({ key: k, value: parseInt((val * 100 / (totales[gk] || 0))) + ' %' });
            else
                item.push({ key: k, value: "0 %" });
        }
        dataTable.push(item);
    }

    // Añadimos texto en blanco para la primera columan de la tabla de datos
    headers.unshift("");

    const legendNode = legendContainer.node();
    if (legendNode && legendNode.parentNode) {
        const container = d3.select(legendNode.parentNode);
        let legend2 = container.append("div").attr("class", "DashboardLegend").style("padding-left", "50px");
        // Creamos tabla para los datos de la leyenda
        let table = legend2
            .append("table")
            .attr("class", "DashboardLegendTable")
            .style("border-collapse", "separate");

        // Creamos cabeceras
        table
            .append("thead")
            .append("tr")
            .selectAll("th")
            .data(headers)
            .enter()
            .append("th")
            .attr("class", (d, i) => i == 0 ? "DashboardLegendTableTH" : "DashboardLegendTableTH DashboardLegendRowSep")
            .attr("colspan", (d, i) => i == 0 ? 1 : 2)
            .text(d => d);

        //Añadimos datos
        table
            .append("tbody")
            .selectAll("tr")
            .data(dataTable)
            .enter()
            .append("tr")
            .selectAll("td")
            .data(d => d)
            .enter()
            .append("td")
            .attr("class", "DashboardLegendTableTD")
            .style("padding", function (d, i) { return i == 0 ? "3px 15px 3px 15px" : i % 2 != 0 ? "3px 15px" : "3px 0px 3px 15px" })
            .style("text-align", function (d, i) { return i == 0 ? "left" : "right" })
            .style("color", function (d, i) { return i == 0 ? "#000000" : i % 2 == 0 ? d3.color(colors(d.key)) : "#ffffff" })
            .style("background-color", function (d, i) { return i % 2 != 0 ? d3.color(colors(d.key)) : "inherit" })
            .style("border-radius", "3px")
            .html(function (d, i) {
                return i > 0 || equivalences[d.value] == undefined ? d.value : equivalences[d.value];
            });

    }





}

/********************************************************************************************************************************************************
 * Funciones
*********************************************************************************************************************************************************/
function GetSubCategories(data, series) {
    // Recuperamos series del listado
    let subcategoriesSet = new Set();
    series.forEach((serie) => {
        subcategoriesSet.add(serie.Name);
    });

    // Recuperamos series de los datos (por si no se han definido todas la series)
    for (let [key, value] of Object.entries(data)) {
        for (let [k, v] of Object.entries(value)) {
            subcategoriesSet.add(k);
        }
    }

    // Devolvemos los valores únicos de series
    return Array.from(subcategoriesSet);
}

function GetSeriesColors(subcategories, series) {
    // Generamos un listado de colores basados en el domain de subcategorías
    const randomColors = d3
        .scaleOrdinal()
        .domain(subcategories)
        .range(d3
            .quantize(
                (t) => d3.interpolateSpectral(t * 0.8 + 0.1),
                subcategories.length // Cambiar para usar la longitud de subcategorías
            )
            .reverse()
        );

    // Generamos un listado con los colores custom encontrados, y random para el resto
    let finalColors = {};
    for (let key of subcategories) {
        let serie = series.find((item) => item.Name == key);
        if (serie) {
            finalColors[key] = serie.Color;
        } else {
            finalColors[key] = randomColors(key);
        }
    }

    // Devolvemos esquema de colores
    return d3.scaleOrdinal()
        .domain(Object.keys(finalColors))
        .range(Object.values(finalColors));
}
